module.exports = __webpack_public_path__ + "img/photoshop.82142841.svg";